import { render, staticRenderFns } from "./CorrespondenceSent.vue?vue&type=template&id=0bd79488&scoped=true&"
import script from "./CorrespondenceSent.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceSent.vue?vue&type=script&lang=js&"
import style0 from "./CorrespondenceSent.vue?vue&type=style&index=0&id=0bd79488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd79488",
  null
  
)

export default component.exports